import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pt-10 row g-5 g-xl-8 d-flex justify-content-center" }
const _hoisted_2 = { class: "card mw-800px" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "text-center fs-2 fw-bolder mb-10" }
const _hoisted_5 = { class: "d-flex justify-content-center mb-10" }
const _hoisted_6 = { class: "badge badge-warning" }
const _hoisted_7 = { class: "badge badge-primary mx-2" }
const _hoisted_8 = { class: "d-flex justify-content-center mb-10" }
const _hoisted_9 = { class: "svg-icon svg-icon-warning svg-icon-5x" }
const _hoisted_10 = { class: "fs-1 text-center fw-bolder mb-10" }
const _hoisted_11 = { class: "d-flex justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.data.title), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, "Siri " + _toDisplayString(_ctx.data.siri), 1),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.data.tahun), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, [
            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen044.svg" })
          ])
        ]),
        _createElementVNode("div", _hoisted_10, " Permohonan anda telah dihalang disebabkan \"" + _toDisplayString(_ctx.data.message) + "\" ", 1),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_router_link, {
            to: { name: 'rayuan-permohonan', params: { id: _ctx.data.id } },
            class: "btn btn-light-success mx-2"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Buat Rayuan")
            ]),
            _: 1
          }, 8, ["to"]),
          _createVNode(_component_router_link, {
            to: "/",
            class: "btn btn-light-primary mx-2"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Keluar")
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}